import classNames from "classnames";

export function ProgressBar({
  progress,
  size = "large",
  hideLabel = false,
}: {
  progress: number;
  size?: "small" | "large";
  hideLabel?: boolean;
}) {
  const maxProgress = progress < 100 ? progress : 100;
  return (
    <div className={classNames(size === "large" && "rounded-full", "w-full bg-border")}>
      <div
        className={classNames(
          size === "small" ? "text-[11px] py-1 px-0" : "text-xs py-2 px-0 rounded-full",
          hideLabel && "min-h-[12px]",
          "bg-purple-600 font-medium text-white text-center leading-none",
        )}
        style={{ width: `${maxProgress}%` }}
      >
        {!hideLabel ? `${maxProgress}%` : " "}
      </div>
    </div>
  );
}
